import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import wait from "../../utility/wait.js";

const successTimer = 3500;

const sliceName = "successSlice";

const initialState = {
  showSuccessBucket: [],
  successMsg: "",
};

const showSuccess = (state, { payload, type }) => {
  state.showSuccess = true;
  state.successMsg = payload.msg;
};
const hideSuccess = (state, { payload, type }) => {
  state.showSuccess = false;
  state.successMsg = "";
};

let showAsyncSuccess = async (_, thunkAPI) => {
  const response = await wait(successTimer);
  return response;
};

showAsyncSuccess = createAsyncThunk(
  `${sliceName}/showAsyncSuccess`,
  showAsyncSuccess
);
showAsyncSuccess.myLC = {
  pending: (state, action) => {
    state.successMsg = action.meta?.arg?.msg;
    state.showSuccessBucket.push({});
  },
  fulfilled: (state, action) => {
    state.showSuccessBucket.shift();

    if (state.showSuccessBucket.length === 0) {
      state.successMsg = "";
    }
  },
  rejected: (state, action) => {
    state.showSuccessBucket.shift();
  },
};

//////////////////////////////////////////////////////////////// SLICE

const loadingSlice = createSlice({
  name: sliceName,
  initialState: initialState,
  reducers: { showSuccess, hideSuccess },
  extraReducers: (builder) => {
    builder.addCase(showAsyncSuccess.pending, showAsyncSuccess.myLC.pending);
    builder.addCase(
      showAsyncSuccess.fulfilled,
      showAsyncSuccess.myLC.fulfilled
    );
    builder.addCase(showAsyncSuccess.rejected, showAsyncSuccess.myLC.rejected);
  },
});

export const asyncActions = { showAsyncSuccess };
export const actions = loadingSlice.actions;
export default loadingSlice.reducer;
